// formSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ReviewFormState {
  isReviewForm: boolean;
}

const initialState: ReviewFormState = {
  isReviewForm: false,
};

export const reviewFormSlice = createSlice({
  name: 'reviewForm',
  initialState,
  reducers: {
    setReviewForm: (state, action: PayloadAction<boolean>) => {
      state.isReviewForm = action.payload;
    },
  },
});

export const { setReviewForm } = reviewFormSlice.actions;

export default reviewFormSlice.reducer;
